import template from './payment-notice.html';
import controller from './payment-notice.controller';
import './payment-notice.scss';

let PaymentNoticeComponent = {
  bindings: {},
  template,
  controller
};

export default PaymentNoticeComponent;



// WEBPACK FOOTER //
// ./src/app/pages/payment-notice/payment-notice.component.js